import apiClient from './apiClient';

export const rechnungApi = {
  // Alle Rechnungen
  getRechnungen: async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const response = await apiClient.get(`/rechnungen${queryString ? `?${queryString}` : ''}`);
    return response.data;
  },

  // Einzelne Rechnung
  getRechnung: async (id) => {
    const response = await apiClient.get(`/rechnungen/${id}`);
    return response.data;
  },

  // Rechnung erstellen
  createRechnung: async (data) => {
    const response = await apiClient.post('/rechnungen', data);
    return response.data;
  },

  // Rechnung aktualisieren
  updateRechnung: async (id, data) => {
    const response = await apiClient.put(`/rechnungen/${id}`, data);
    return response.data;
  },

  // Rechnung löschen
  deleteRechnung: async (id) => {
    const response = await apiClient.delete(`/rechnungen/${id}`);
    return response.data;
  },

  // Stornorechnung erstellen
  createStornorechnung: async (id) => {
    const response = await apiClient.post(`/rechnungen/${id}/storno`);
    return response.data;
  },

  // Rechnung per E-Mail versenden
  sendRechnung: async (id) => {
    const response = await apiClient.post(`/rechnungen/${id}/send`);
    return response.data;
  },

  // PDF URL
  getPdfUrl: (rechnung) => {
    if (!rechnung.pdfPfad) return null;
    // baseURL ist http://localhost:3000/api, aber pdfPfad enthält bereits /api/uploads/...
    // Daher nur die Server-URL ohne /api verwenden
    const serverURL = import.meta.env.VITE_API_URL
      ? import.meta.env.VITE_API_URL.replace(/\/api$/, '')
      : 'http://localhost:3000';
    return `${serverURL}${rechnung.pdfPfad}`;
  }
};

export default rechnungApi;
